module.exports = __webpack_public_path__ + "img/null-data.4b214748.png";